// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivatePWAModal_wrapper__LEO-t","warning":"ActivatePWAModal_warning__9eosA","warningInfo":"ActivatePWAModal_warningInfo__zv9lp","icon":"ActivatePWAModal_icon__Y6z4I"};